/**
 * A service's page (`/services/:serviceId/:nameSlug?`, web-client-app D11, task 8.7):
 * the service page piece with the photo gallery and the booking column in it.
 * A service the studio does not list shows the studio's not-found page.
 */
import { BookingColumn } from '../pieces/booking-column';
import { MessageStudio } from '../pieces/message-studio';
import { PhotoGallery } from '../pieces/photo-gallery';
import { PhoneServicePage } from '../phone/PhoneServicePage';
import { ServicePageView, useServicePage } from '../pieces/service-page';
import { readSite } from '../site';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';
import { NotFoundPage } from './NotFoundPage';

export function ServicePage() {
  const page = useServicePage();
  const phone = useAppScreens();
  usePageTitle(page.state.service?.name);
  if (page.state.status === 'not-found') return <NotFoundPage />;
  // Below 768px the page is the Mini App's service page (Gabriel 2026-10-21).
  if (phone) return <PhoneServicePage service={page.state.service} />;
  // web-studio-sites D15: Message the studio under the details when her site turns it on.
  const message = readSite()?.telifyPages.messageStudio ? <MessageStudio about="service" /> : undefined;
  return <ServicePageView {...page} photos={<PhotoGallery />} booking={<BookingColumn />} message={message} />;
}
